import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import IGotoComponent, { IGotoOption } from '@components/FormFlow/Interfaces/FormflowComponents/IGotoComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Col, Icon, Input, InputNumber, Row, Select } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { InstructionTaskComponent } from '../TextInstructionComponent';

const Option = Select.Option;
let isValidate: any = []

interface IGoToTaskComponentStateType {
  instructionTitle: string;
  newOrExistingItemList?: string;
  conditionsTaskComponents: boolean;
  required: boolean;
  description?: string;
  repeat: boolean | undefined;
  minRepeat?: any;
  maxRepeat?: any;
  multiple: boolean;
  minMultiple?: any;
  maxMultiple?: any;
  options: IGotoOption[];
  isSample: boolean;
};

export class GoToComponent implements IGotoComponent {
  id: string;
  required: boolean;
  type: ComponentType;
  title: string;
  description?: string;
  repeat?: boolean;
  minRepeat: number;
  maxRepeat: number;
  options: IGotoOption[];
  multiple: boolean;
  minMultiple: number;
  maxMultiple: number;

  constructor() {
    this.id = '';
    this.required = false;
    this.type = ComponentType.GOTO;
    this.title = '';
    this.repeat = undefined;
    this.minRepeat = 0;
    this.maxRepeat = 999;
    this.options = [{
      id: Date.now(),
      sectionId: undefined,
      label: undefined,
      samples: undefined
    }];
    this.multiple = false;
    this.minMultiple = 0;
    this.maxMultiple = 999;
    return this;
  }
}

export default class GoToTaskComponent extends React.Component<IGotoComponent, IGoToTaskComponentStateType> {

  constructor(props: IGotoComponent) {
    super(props);
    this.state = {
      instructionTitle: '',
      conditionsTaskComponents: true,
      // selectGoTo: [{ sectionsID: '' }],
      description: this.props.description,
      required: this.props.required || false,
      repeat: this.props.repeat,
      multiple: this.props.multiple || false,
      minMultiple: this.props.minMultiple,
      maxMultiple: this.props.maxMultiple || 999,
      options: this.props.options,
      minRepeat: this.props.minRepeat,
      maxRepeat: this.props.maxRepeat || 999,
      isSample: false
    };
  }

  componentDidMount() {
    this.setState({ instructionTitle: this.props.title ? this.props.title : '' })
    if (this.props.options) {
      this.setState({ options: this.props.options })
    }
    else if (!!this.props.options) {
      this.setState({ options: [{ id: Date.now(), sectionId: '', label: '', samples: undefined }] })
    }
  }

  UNSAFE_componentWillMount() {
    for (const itemsOptions of this.state.options) {
      if (itemsOptions.samples !== undefined) {
        this.setState({ isSample: true })
      }
    }
  }

  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }
  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }

  handleRequiredChange = async (evt: any) => {
    this.setState({ required: evt.target.checked });
    if (this.state.required) {
      this.setState({ minRepeat: 1, minMultiple: 1 })
    }
    else if (!this.state.required) {
      this.setState({ minRepeat: 0, minMultiple: 0 })
    }
  }
  handleSampledChange = async (evt: any) => {
    this.setState({ isSample: evt.target.checked });
  }
  handleRepeatChange = async (evt: any) => {
    this.setState({ repeat: evt.target.value });
    if (this.state.repeat && !this.state.required) {
      this.setState({ minMultiple: 0, minRepeat: 0, multiple: false })
    }
    else if (this.state.repeat && this.state.required) {
      this.setState({ minMultiple: 1, minRepeat: 1, multiple: false })
    }
    else if (!this.state.repeat && this.state.required) {
      this.setState({ minRepeat: 1, minMultiple: 1, multiple: true })
    }
    else if (!this.state.repeat && !this.state.required) {
      this.setState({ minRepeat: 0, minMultiple: 0, multiple: true })
    }
  }
  handleRepeatMin = async (evt: any) => {
    this.setState({ minRepeat: evt });
  }
  handleRepeatMax = async (evt: any) => {
    this.setState({ maxRepeat: evt });
  }
  handleMultpleMin = async (evt: any) => {
    this.setState({ minMultiple: evt });
  }
  handleMultipleMax = async (evt: any) => {
    this.setState({ maxMultiple: evt });
  }

  handleInputItemChange = (idx: any) => (evt: any) => {
    const selectGoTo = this.state.options.map((selectGoToItems, sidx) => {
      if (idx !== sidx) return selectGoToItems;
      return { ...selectGoToItems, sectionId: evt };
    });
    this.setState({ options: selectGoTo });
  }
  handleInputLabelChange = (idx: any) => (evt: any) => {
    const selectGoTo = this.state.options.map((selectGoToItems, sidx) => {
      if (idx !== sidx) return selectGoToItems;
      return { ...selectGoToItems, label: evt.target.value };
    });
    this.setState({ options: selectGoTo });
  }

  handleInputSampleChange = (idx: any) => (evt: any) => {
    const selectGoTo = this.state.options.map((selectGoToItems, sidx) => {
      if (idx !== sidx) return selectGoToItems;
      return { ...selectGoToItems, samples: evt };
    });
    this.setState({ options: selectGoTo });
  }

  handleAddNewSelectGoTo = async () => {
    this.setState({
      options: this.state.options.concat([{ id: Date.now(), sectionId: undefined, label: '', samples: undefined }]),
    });
  }

  handleRemoveSelectGoTo = (index: number) => async () => {
    this.setState({
      options: this.state.options.filter((section: any, sindex: number) => index !== sindex),
    });
  }

  isDisabled = async () => {
    for (let itemsValidate of this.state.options) {
      if (itemsValidate.sectionId === undefined) {
        isValidate.push(false)
      }
      else if (itemsValidate.label === '' || itemsValidate.label === undefined) {
        isValidate.push(false)
      }
      else {
        isValidate = []
      }
    }
  }

  validationSectionId(items: any) {
    this.isDisabled()
    let fieldIsRequired: JSX.Element = <div />;
    if (items.sectionId === undefined) {
      fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
    }
    return fieldIsRequired;
  }

  validationLabel(items: any) {
    this.isDisabled()
    let fieldIsRequired: JSX.Element = <div />;
    if (items.label === undefined || items.label === '') {
      fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
    }
    return fieldIsRequired;
  }

  onSubmiGoToComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    const newTextDataComponent: IGotoComponent = {
      id: this.props.id,
      type: ComponentType.GOTO,
      title: this.state.instructionTitle,
      description: this.state.description,
      required: this.state.required,
      repeat: this.state.repeat,
      minRepeat: this.state.repeat ? this.state.minRepeat : this.state.isSample ? null : 0,
      maxRepeat: this.state.repeat ? this.state.maxRepeat : this.state.isSample ? null : 0,
      multiple: this.state.multiple,
      minMultiple: this.state.multiple ? this.state.minMultiple : this.state.isSample ? null : 0,
      maxMultiple: this.state.multiple ? this.state.maxMultiple : this.state.isSample ? null : 0,
      options: this.state.options,
    }

    updateFormflowWithComponent(newTextDataComponent);
  }

  render() {
    const {
      options,
      instructionTitle,
      required,
      repeat,
      description,

    } = this.state;

    return (
      <Wrapper>
        <InstructionTaskComponent
          conditionsTaskComponents={true}
          gotoSectonOption={true}
          inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
          visibleDescription={true}
          gotoitems={this.state.options.length}
          inputTitleValue={instructionTitle}
          valueRadioGoTo={repeat}
          requiredCheckedValue={required}
          onChangedSample={this.handleSampledChange}
          onInputInstructionChange={() => this.handleIntructionTitleChange}
          onChangeDescription={() => this.handleDescriptionChange}
          onChangeRequiredCheckbox={() => this.handleRequiredChange}
          onChangeGoToRepeat={this.handleRepeatChange}
          onChangeRepeatGoToMin={this.handleRepeatMin}
          onChangeRepeatGoToMax={this.handleRepeatMax}
          onChangeMultipleMin={this.handleMultpleMin}
          onChangeMultipleMax={this.handleMultipleMax}
          valueRepeatGoToMin={this.state.minRepeat}
          valueRepeatGoToMax={this.state.maxRepeat}
          valueMultipleMin={this.state.minMultiple}
          valueMultipleMax={this.state.maxMultiple}
          titleComponent={I18n.l("formflow.components.goToComponent.titleGoToComponent")}
          descriptionComponent={I18n.l("formflow.components.goToComponent.descriptionGoToComponent")}
          exampleDescriptionComponent={I18n.l("formflow.components.goToComponent.exampleDescriptionGoToComponent")}
        />
        <div>
          <DividerBorder />
          <Row>
            <p className='select-title-style' >{I18n.l("formflow.components.goToComponent.titleGoToSelect")}</p>
            {this.state.options.map((gotoItems: any, idx: number) => (
              <Row>
                <div key={idx}>
                  <div className="select-item-style" >
                    <Col sm={6} md={6} xl={6}>
                      <FormflowContext.Consumer>
                        {({ sections }) => (
                          <Select defaultValue={gotoItems.sectionId} onChange={this.handleInputItemChange(idx)} placeholder={I18n.l("formflow.components.goToComponent.selectGoToPlaceHolder")} style={{ width: '100%' }}>
                            {sections.map((section, index) => (
                              <Option key={index} value={section.id}>
                                {section.id}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </FormflowContext.Consumer>
                      <div style={{ marginBottom: '10px' }}>
                        {this.validationSectionId(gotoItems)}
                      </div>
                    </Col>
                    <Col sm={8} md={8} xl={8}>
                      <Input
                        defaultValue={gotoItems.label}
                        placeholder={I18n.l("formflow.conditions.GoToComponentPlaceholder")}
                        onChange={this.handleInputLabelChange(idx)}
                        style={gotoItems.label === '' || gotoItems.label === undefined ? { borderColor: `${Theme.secondary.red}`, marginLeft: '10px', width: '100%' } : { marginLeft: '10px', width: '100%' }}
                      />
                      <div style={{ marginLeft: '15px', marginBottom: '10px' }} >{this.validationLabel(gotoItems)}</div>
                    </Col>

                    {this.state.isSample &&
                      <Col sm={2} md={2} xl={2}>
                        <InputNumber
                          min={1}
                          defaultValue={gotoItems.samples}
                          placeholder={'n°'}
                          onChange={this.handleInputSampleChange(idx)}
                          style={{ marginLeft: '20px', width: '100%' }}
                        />
                      </Col>
                    }
                    <Icon
                      style={this.state.isSample ? { color: 'red', marginLeft: '30px', marginTop: '10px', cursor: "pointer" } : { color: 'red', marginLeft: '20px', marginTop: '10px', cursor: "pointer" }}
                      type="close"
                      onClick={this.handleRemoveSelectGoTo(idx)}
                    />
                  </div>
                </div>
              </Row>
            ))}
          </Row>
          {!this.state.repeat &&
            <ButtonStyle>
              <Button onClick={this.handleAddNewSelectGoTo} className="goepik-btn-border-main">
                <Icon type="plus" /> {I18n.l("formflow.buttons.addSection").toUpperCase()}
              </Button>
            </ButtonStyle>
          }
        </div>
        <FormflowContext.Consumer>
          {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
            <div>
              <ButtonStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                  <Button className="button-save" type="primary" disabled={instructionTitle.length === 0 || instructionTitle.length < 3 || isValidate.length !== 0 ? true : false} onClick={() => { this.onSubmiGoToComponent(updateFormflowWithComponent) }} >{I18n.l('common.save')}</Button>
                </Row>
              </ButtonStyle>
            </div>
          )}
        </FormflowContext.Consumer>
      </Wrapper>
    );
  }
}
const Wrapper = styled.div`
    width:100%;
    margin-bottom: 10rem;
    .optional-validation-condition-text{
        font-weight: bold;
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-checkbox-validation{
        width:50%;
        margin-top: 1rem;

    }
    .text-input-validation{
        width: 70px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
    }
    .select-item-style{
        margin-bottom: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 100%;
    }
    .select-title-style{
        margin-top: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 80%;
    }
    .delete-style{
        margin-top: 2rem;
    }
    .count-input{
        margin-top:2px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        margin-top:2px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
      .apply-shake {
          animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      }

`

const DividerBorder = styled.div`
    margin-top: 2rem;
    margin-left: 3rem;
    margin-right: 3rem;   
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`
const ButtonStyle = styled.div`
    margin-left: 3rem;
    margin-right: 3rem;   
`